import NavigateBackComponent from './NavigateBackComponent';

export default NavigateBackComponent;
